<template>
 <ur-area>
  <div class="wrap">
    <div class="contents_wrap">
      <section>
        <div class="contents admission">
                <h2>계정만들기</h2>
                <div class="apply_formbox w458">
                    <label>
                        이메일<em class="essential"> *</em>
                    </label>
                    <div class="find_form">
                        <input type="text" id="loginId" v-model="otpSendAsk.loginId" readonly="readonly">
                    </div>
                    <ur-button class="btn_login" :disabled="isOTPDisabledBtn" @click="sendOtp" width="100%"> 코드 전송</ur-button>
                    <label v-if="showLabel">
                        코드<em class="essential"> *</em>
                    </label>
                    <div id="otp_inprogress" hidden>              
                    <div class="find_form">
                        <input type="text"  v-model="otpSendAsk.otp" @keyup.enter="verifyOtp" width="100%" >
                        <span v-if="isOTPError" class="error">{{ OTPErrorMessage }} </span>                                                
                        <span  class="display">{{ guideMessage }}</span>                        
                    </div>
                      <ur-button class="btn_login" :disabled="isOTPVerifyDisabledBtn" @click="verifyOtp" width="100%">인증</ur-button>
                  </div>            
                    <label>
                        비밀번호<em class="essential"> *</em>
                    </label>
                    <div class="find_form">                      
                        <ur-text-field type="password" v-model="admitSendAsk.password" id="newPw"   @focus="handleInputFocus" @blur="handleInputBlur" autocomplete="off" placeholder="영문+숫자+특수기호 포함 8~12자리" width="100%" ref="password" />                      
                        <!-- isFocused 값에 따라 클래스를 동적으로 추가/제거합니다. -->
                        <div class="changepw_popup" :style="{ display: isPopupVisible ? 'block' : 'none' }">
                            <ul class="pw_hint_list">
                                <li :class="{'correct': isPasswordCorrectLength, 'wrong': isPasswordWrongLength }">비밀번호는 8-12자만 사용 가능</li>
                                <li :class="{'correct': isMixedCorrect, 'wrong': isMixedWrong }">영문자, 숫자, 특수문자 혼합작성</li>
                                <li :class="{'correct': isNotIdenticalConsecutive, 'wrong': isIdenticalConsecutive }">동일한 숫자/문자 3자 이상 연속 사용 불가</li>
                                <li :class="{'correct': isNotConsecutive, 'wrong': isConsecutive }">연속된 숫자/문자 4자 이상 사용 불가</li>
                            </ul>
                        </div>
                    </div>
                    <label>
                        비밀번호 확인<em class="essential"> *</em>
                    </label>
                    <div class="find_form">
                       <ur-text-field type="password" v-model="confirmPassword" id="confirmPw" placeholder="새 비밀번호 재입력" :rules="passwordCheckValidateRule"  @focus="handleConfirmInputFocus" autocomplete="off" width="100%" />                      
                    </div>
                    <label>
                        이름<em class="essential"> *</em>
                    </label>
                    <div class="find_form">
                        <input type="text" id="cn" v-model="admitSendAsk.userName" @keyup.enter="onClickRegister()" maxlength="50" autocomplete="off">
                        <span class="error" id="caution_cn"></span>
                    </div>
                    <div class="btn_wrap" align="center">
                      <ur-button size="large" @click="onClickCancel()">취소</ur-button>
                      <ur-button solid primary size="large" :disabled="isRegisterDisabledBtn" @click="onClickRegister()" main>등록</ur-button>
                    </div>
                 </div>
             </div>          
         </section>
      <!-- Admission Success Modal -->
      <ur-modal ref="successModal" :title="'확인'" small @closed="gotoLoginPage()">
        <template>
          등록되었습니다
        </template>
        <template slot="action">
          <ur-button shape="solid" primary @click="confirmSuccess()" >확인</ur-button>
        </template>
      </ur-modal>
    </div>
  </div>
</ur-area>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import AuthManager from '~system/auth/AuthManager';
//import '~assets/css/aicc/home.css';/* css 파일 내 home_footer class 스타일을 가져오기 위한 import  */
import ReplyCode from '~modules/AI/js/ReplyCode.js';
import ERROR_TYPE from '~common/js/error-type.js';

export default {
  name: 'InviteAdmission',
  // extends: BasePage,
  data() {
    return {
      admitSendAsk: {
        tenantId:'',
        email: '',
        password: '',        
        userName: '',
      },
      confirmPassword:'',
      otpSendAsk: {
        ccUrl: '',
        loginId: '',
        otp: '',
        otpType: 'B',
      },
      isPopupVisible: false, // 팝업 힌트의 표시 여부를 저장할 데이터 속성
      otpSendFlag: true,   //OTP 코드 받기 버튼 활성화
      otpVerifiedFlag: false, //OTP 검증 완료
      otpSendCompletedFlag: false, //OTP 전송 완료
      passwordCheckValidateRule: [
        (v) => this.isEqual || '비밀번호가 일치하지 않습니다.',
      ],
      // otp timer      
      startTime: null, //otp code 받기 시작 시간
      leftTime: 0,  //otp code 받기 잔여 시간
      showTimer: false,
      timerId: '',
      showLabel: false,  //코드 라벨 표시
      isOTPError: false, // OTP error
      OTPErrorMessage: "",
    };
  },
  created(){     
    },
  beforeDestroy() {
    this.stopTimer();
    AuthManager.removeSession().then(data => { // 화면을 벗어날 때 session 초기화
    }).catch(err => {
      console.warn(err);
    });
  },    
  mounted(){
    //this.$store.commit('hideGnbMenu');
    //this.$store.commit('showFooter');
    console.log(this.$store.state);
    this.$store.state.isGnbMenuShowed = false;
    this.$store.state.lnbShowed = false;
    console.log("sessionStorage inviteToken", sessionStorage.getItem("inviteToken"));       
    this.getInviteUserInfo(sessionStorage.getItem("inviteToken"));
    },  
  computed: {
    // otp timer
    guideMessage() {
      if (this.showTimer) {
        const minutes = Math.floor(this.leftTime / 60);
        const seconds = this.leftTime % 60;
        return `남은시간 ${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      }
      return '';
    },
    // OTP 인증하기 버튼 비활성화 여부
    isOTPVerifyDisabledBtn() {
      if (this.otpSendCompletedFlag && this.isOTPValidLength ) {
        return false;
      }else{
        return true;
      }
    },
    // OTP 코드 받기 버튼 비활성화 여부
    isOTPDisabledBtn() {
      if(this.otpSendCompletedFlag){
        return true;  
      }else{
        if (!utils.isEmailFormat(this.otpSendAsk.loginId) || this.otpSendFlag) {
          return false;
        }
      }
    },
    // OTP Code 길이 6자리
    isOTPValidLength() {
      return this.otpSendAsk.otp.length == 6;
    },
    // 회원 등록 버튼 비활성화 여부
    isRegisterDisabledBtn() {
      if (this.otpVerifiedFlag && this.isNameEntered && this.isPasswordCorrectLength && this.isMixedCorrect && this.isNotIdenticalConsecutive && this.isNotConsecutive && this.isEqual) {
        return false;
      }
        return true;
    },
    // 재설정 코드 발송시 vuex에 저장한 loginId 조회
    loginId() {
      return this.$store.getters.getLoginId;
    },
    // 이름 입력
    isNameEntered() {
      return this.admitSendAsk.userName.length > 0;
    },
    // 비밀번호는 8-12자만 사용 가능
    isPasswordCorrectLength() {
      if(aiccUtils.passwordValidation.isValidLength(this.admitSendAsk.password)){
        return true;
      }
    },
    
  // 비밀번호는 사용 가능 길이 8~12자 벗어남
    isPasswordWrongLength() {
      if (this.admitSendAsk.password.length == 0){
        return false;
      }
      if(!aiccUtils.passwordValidation.isValidLength(this.admitSendAsk.password)){
        return true;
      }     
    },
    // 영문, 숫자, 특수문자(`~!@#$%^&*|\'";:/?) 혼합
    isMixedCorrect() {
      if (aiccUtils.passwordValidation.isMixed(this.admitSendAsk.password)) {
        return true;
      } 
    },
    // 영문, 숫자, 특수문자(`~!@#$%^&*|\'";:/?) 혼합 wrong
    isMixedWrong() {
      if (this.admitSendAsk.password.length == 0){
        return false;
      }
      if (!aiccUtils.passwordValidation.isMixed(this.admitSendAsk.password)) {
        return true;
      }      
    },
    // 동일한 문자 3개 이상 금지
    isNotIdenticalConsecutive() {
      if(aiccUtils.passwordValidation.isNotIdenticalConsecutive(this.admitSendAsk.password)){
        return true;
      }
    },
    // 동일한 문자 3개 이상 금지 위반
    isIdenticalConsecutive() {
      if (this.admitSendAsk.password.length == 0){
        return false;
      }
      if(!aiccUtils.passwordValidation.isNotIdenticalConsecutive(this.admitSendAsk.password)){
        return true;
      }
    },
    // 연속된 영문, 숫자 4개 이상 금지
    isNotConsecutive() {
      if(aiccUtils.passwordValidation.isNotConsecutive(this.admitSendAsk.password)){
        return true;
      }
    },
    // 연속된 영문, 숫자 4개 이상 금지 위반
    isConsecutive() {
      if (this.admitSendAsk.password.length == 0){
        return false;
      }
      if(!aiccUtils.passwordValidation.isNotConsecutive(this.admitSendAsk.password)){
        return true;
      }
    },
    // 비밀번호 동일 여부 확인
    isEqual() {
      if (this.admitSendAsk.password.length == 0){
        return true;
      }
      return aiccUtils.passwordValidation.isEqual(this.admitSendAsk.password, this.confirmPassword);
    },
  },
  methods: {  
    handleInputFocus() {
      this.isPopupVisible = true;
    },
    handleInputBlur() {
      this.isPopupVisible = false;
    },
    handleConfirmInputFocus() {
      if (this.isPasswordWrongLength || this.isMixedWrong || this.isIdenticalConsecutive || this.isConsecutive) {
        this.isPopupVisible = true;
      }  
    },
    getInviteUserInfo(token){    //토큰 이용하여 사용자 초대 정보 조회
      AuthManager.getInviteUserInfo(token).then(data => {   
        if (data.reply.code === ReplyCode.NO_ERROR) { // 성공                             
            console.log("성공");                                     
            this.admitSendAsk.tenantId = data.inviteUserInfoDVO.tenantId;
            this.admitSendAsk.email = data.inviteUserInfoDVO.email;
            this.otpSendAsk.loginId = this.admitSendAsk.email;
            console.log("inviteUserInfo", this.inviteUserInfo);                    
        } else { // 
            console.warn("실패");            
        }
      }).catch(err => { // 재설정 코드발송 실패
        console.warn(err);            
      });
    },
    // 재설정 코드 발송
    sendOtp() {
      // OTP 코드 받기 버튼 중복 클릭 방지
      if (this.otpSendFlag === false) {
        return;
      }
      this.otpSendFlag = false; // OTP 코드 받기 버튼 비활성화
      
      this.otpSendAsk.ccUrl = aiccUtils.urlUtil.getCcUrl(); // pathname(/home/{ccUrl} 형식)에서 ccUrl 추출
      console.log("this.otpSendAsk.ccUrl", this.otpSendAsk.ccUrl);
      this.otpSendAsk.otp = "";  
      AuthManager.sendOtp(this.otpSendAsk).then(data => {
        if (data.reply.code === ReplyCode.NO_ERROR) { // 재설정 코드 발송 성공
          utils.aiccMessageBox('확인', "이메일 주소로 회원가입 인증을 위한 코드를 보냈습니다.", '확인');
          this.otpSendCompletedFlag = true; // OTP 전송 완료 후 코드 받기 버튼 비활성화          
          otp_inprogress.removeAttribute('hidden');           
          this.showLabel = true;           
          this.$store.commit('setLoginId', this.otpSendAsk.loginId);
          this.startTimer(); //otp 타이머 시작
          this.OTPErrorMessage = "";
        } else { // 재설정 코드 발송 실패
          utils.aiccMessageBox('확인', data.reply.korMsg, '확인');
        }
      }).catch(err => { // 재설정 코드발송 실패
        console.warn(err);
      });
    },
    verifyOtp() {
      // validation check
      if (this.isOTPVerifyDisabledBtn) {
        return;
      }
      AuthManager.verifyOtp(this.otpSendAsk).then(data => {
        if (data.reply.code === ReplyCode.NO_ERROR) { // 재설정 코드 확인 성공
          console.log("verifyOtp success");
          utils.aiccMessageBox('확인', "정상적으로 인증 되었습니다.", '확인');
          this.stopTimer();
          this.$store.commit('setOtp', this.otpSendAsk.otp);
          otp_inprogress.setAttribute('hidden', true);    
          this.showLabel = false;             
          this.otpVerifiedFlag = true;      
        } else { // 재설정 코드 확인 실패
          console.log("verifyOtp fail");
          console.log("data.reply.code", data.reply.code);
          this.isOTPError = true;
          if (data.reply.code === ReplyCode.OTP_NOT_MATCH_5) { // 재설정 코드 5회 이상 실패
            this.OTPErrorMessage = data.reply.korMsg;
            this.stopTimer();
            this.otpSendFlag = true;   //OTP 코드 받기 버튼 활성화
            this.otpSendCompletedFlag = false; //OTP 전송 미완료
            this.otpSendAsk.otp = "";  
          } else if (data.reply.code === ReplyCode.OTP_NOT_MATCH) { // 재설정 코드 1~4회 이상 실패
            this.OTPErrorMessage = data.customMsg; // 오류 메시지에 실패 횟수가 포함되어 있어 customMsg 사용
          } else if (data.reply.code === ReplyCode.OTP_EXPIRED) { // OTP 인증 만료(서버)
            this.stopTimer();
            this.isOTPError = true;
            this.OTPErrorMessage = "입력 시간이 초과되었습니다. 코드를 다시 받아주세요.";          
            this.otpSendFlag = true;   //OTP 코드 받기 버튼 활성화
            this.otpSendCompletedFlag = false; //OTP 전송 미완료
          } else { // 나머지 오류
            this.OTPErrorMessage = data.reply.korMsg;
          }
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    onClickRegister() { //회원 가입 등록
      // validation check
      if (this.isRegisterDisabledBtn) {
        return;
      }
      AuthManager.encrypt(this.admitSendAsk.password).then(encryptedPassword => { // 평문 비밀번호를 암호화
        const admitSendAsk = {
          encryptedPassword,
          userName: this.admitSendAsk.userName,
        };

        AuthManager.createUser(admitSendAsk).then(data => {
          console.log("createUser response",data);
          if (data.reply.code === ReplyCode.NO_ERROR) { // 회원 가입 등록 성공    
            this.$refs.successModal.open();
          } else if (data.reply.code === ReplyCode.OTP_VERIFY_EXPIRED) { // OTP 인증 만료
            utils.aiccMessageBox('확인', data.reply.korMsg, '확인');
            this.stopTimer();
            this.otpSendFlag = true; //OTP 코드 받기 버튼 활성화
            this.otpSendCompletedFlag = false; //OTP 전송 미완료
            this.otpSendAsk.otp = "";
          } else { 
            utils.aiccMessageBox('확인', data.reply.korMsg, '확인');
          }
        }).catch(err => {
          console.warn(err);      
        });
      });
    },
    //OTP 타이머 시작
    startTimer() {
      this.startTime = new Date(); // 타이머 기준이 되는 시작 시간
      this.updateTimer();
      this.showTimer = true;
      this.timerId = setInterval(() => {
        if (this.leftTime <= 0) {
          this.stopTimer();
          this.isOTPError = true;
          this.OTPErrorMessage = "입력 시간이 초과되었습니다. 코드를 다시 받아주세요.";          
          this.otpSendFlag = true;   //OTP 코드 받기 버튼 활성화
          this.otpSendCompletedFlag = false; //OTP 전송 미완료
        } else {
          this.updateTimer();
        }
      }, 1000);
    },
    // 타이머 갱신
    updateTimer() {
      this.leftTime = parseInt(600 - ((new Date() - this.startTime) / 1000)); // 600s부터 카운트 다운
    },
    //OTP 타이머 종료
    stopTimer() {
      this.showTimer = false;
      clearInterval(this.timerId);
      this.timerId = '';
    },
    // 페이지 초기화
    gotoInitialPage() {
      this.otpSendFlag = true;   //OTP 코드 받기 버튼 활성화
      this.otpVerifiedFlag = false; //OTP 검증 완료
      this.otpSendCompletedFlag = false; //OTP 전송 완료
      otp_inprogress.setAttribute('hidden', true);  
      this.showLabel = false;           
      this.otpSendAsk.otp = "";  
      utils.goPage('/InviteAdmission');
    },
    onClickCancel() {
      utils.goPage('/ConfirmPolicy');
    },

    // 로그인 페이지 이동
    gotoLoginPage() {
      window.location.href = location.pathname;
    },

    // 회원 가입 등록 성공 확인
    confirmSuccess() {
      this.$refs.successModal.close();
    },
  },
};
</script>

<style scoped>
.ur-area {
  padding: 0px;
}
.wrap {background-color:white; display: flex; justify-content: center; align-items: center;}

/* ========== input =========== */
.otp {margin-bottom: 5px;}
/* ======= guide message ====== */
.otp ::v-deep .ur-text-field__message {text-align: right; color:#333333;}
/* ========== button ========== */
.error {
  color: red;
}
.btn_wrap{
  margin-top: 10px;  
}
.contents.admission > h2{
  width: 428px;
  margin: 100px auto 0 auto;
  font-size: 44px;
  font-weight: bold;
  text-align: center;
}
.contents.admission > h2 + p{
  width: 428px;
  margin: 12px auto 60px auto;
  font-size: 16px;
  line-height: 1.75;
}
.contents_wrap .contents.admission {width:770px; margin: 0 auto; padding-top: 0px ; padding-bottom: 50px}
*{-webkit-tap-highlight-color: rgba(0, 0, 0, 0);}


.changepw_popup {
  display: none; /* 초기에는 숨김 상태로 설정 */ 
  position: absolute;
  top: 0;
  left: 440px;
  width: 295px;
  background: #fff;
  border: 1px solid #a6a6a6;
}
.changepw_popup::before,
.changepw_popup::after {
  right: 100%;
  top: 23%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.changepw_popup::before {
  border-color: rgba(166, 166, 166, 0);
  border-right-color: #a6a6a6;
  border-width: 10px;
  margin-top: -10px;
}

.changepw_popup::after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 9px;
  margin-top: -9px;
}

.changepw_popup.eng{
  width: 320px;
  letter-spacing: -0.1px;
}
.changepw_popup.eng ul{
  padding: 12px;
}
.changepw_popup ul{
  width: 100%;
  max-width: 320px;
  padding: 12px 15px;
}
.changepw_popup ul li{
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  min-height: 16px;
  line-height: 1.29;
  background: url(../../assets/images/aicc/ic-check-dis-sm.png) no-repeat left top;
  padding-left: 24px;
  margin-bottom: 10px;
  overflow: hidden;
}

.changepw_popup ul li.correct{background: url(../../assets/images/aicc/ic-check-sm.png) no-repeat left top;}
.changepw_popup ul li.wrong{color: #db352e;}
  /* 기본폼 */
  .apply_formbox{
    width: 650px;
    margin: 0 auto;
    padding: 0;
  }
  .apply_formbox.w458{width: 428px;}
  .apply_formbox > label{
    position: relative;
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #000;
    padding-bottom: 10px;
    z-index: 0;  /*  9999-> 0  text overlap*/
  }
  .apply_formbox > label .essential{color: #db352e;}
  .apply_formbox input[type="checkbox"] + label,
  .apply_formbox input[type="radio"] + label{
    display: inline-block;
    width: 188px;
    margin-bottom: 20px;
    margin-right: 13px;
    height: 20px;
  }  
  .apply_formbox .input_id{position: relative; margin-bottom: 26px; z-index: 99;}
  .apply_formbox .input_id > span{
    position: absolute;
    top: 15px;
    right: 147px;
    height: 18px;
    line-height: 18px;
    font-size: 16px;
    color: #666;
  }
  .apply_formbox .input_id input[type="text"]{
    width: 349px;
    height: 48px;
    border: 1px solid #ccc;
    line-height: 1;
    padding: 0 181px 0 16px;
    font-size: 16px;
    overflow: hidden;
    margin-right: 5px;
  }
  .input_id input[type="text"]:focus{border-color: #000}
  .apply_formbox .input_id .btn_check{
    width: 120px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    border: 1px solid #a5a5a5;
    vertical-align: middle;
    background: #fff;
  }
  .apply_formbox .check span.error{
    position: absolute;
    top: 52px;
    left: 0;
    font-size: 12px;
    color: #db352e;
  }
  .apply_formbox .find_form{
    position: relative;
    padding-bottom: 24px;
  }    

  .apply_formbox .find_form input{width: 100%;}
  .apply_formbox .find_form .apply_select a,
  .apply_formbox .find_form span.error{
  position: absolute;
  left: 0;
  bottom: 12px;
  font-size: 12px;
  line-height: 1;
  color: #db352e;
}
.apply_formbox .find_form span.display {
    position: absolute;
    right: 0;
    bottom: 12px;
    font-size: 12px;
    line-height: 1;
    color: black;
}
/* BUTTON */
.btn{
  height: 40px;
  padding: 10px 30px;
  border-radius: 22px;
  border: 1px solid;
  text-align: center;
  font-size: 14px;
  line-height: 1;
  font-weight: 600;
  margin-left: 6px;
}
.btn.pop{
  min-width: 180px;
  height: 48px;
  border-radius: 24px;
  padding: 11px 30px;
  line-height: 1.2;
  margin-left: 12px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -1px;
}
.btn.disabled,
.btn:disabled,.btn:disabled:hover{
  background-color: #f3f3f3;
  border-color: #f3f3f3;
  color: #a6a6a6!important;
  cursor: default!important;
}
input[type="password"]{font-family: sans-serif;}
hr{
  border-top: 1px solid #eee;
  border-bottom: none;
}
button{
  margin: 0;
  padding: 0;  
}
input{
  font-family:'NotoSansCJKkr';
  height: 48px;
  padding: 14px 15px;
  border: 1px solid #a6a6a6;
  box-sizing: border-box;
  vertical-align: middle;
  font-size: 16px;
  line-height: 1;
  color: #000;
  background-color: #fff;
  appearance: none;
  -webkit-appearance: none;
}
input:disabled, select:disabled,
input:read-only{
  background-color: #F7F7F7!important;
  appearance: none;
  -ms-appearance: none;
  -webkit-appearance: none;
}
input.disabled{background-color: #F7F7F7!important;}
input[type="text"]:focus,
input[type="password"]:focus{
  border-color: #000;
  border-width: 1px;
  outline: none;
}
input.error{border-color: #db352e;}
.apply_formbox .btn_login {display: block; width: 100%; height: 48px;line-height: 46px; margin-top:0px; margin-bottom:24px; background-color:#516af4; font-size: 18px; color:#fff; text-align: center; border: none;}
.apply_formbox .btn_login:hover {background-color:#516af4;}
.apply_formbox .ur-button--disabled {background-color: #f7f7f7 ;color:#a5a5a5;}

</style>

